<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import 'normalize.css'

export default {
  created () {
    const root = document.documentElement
    root.style.setProperty('--primary-color', process.env.VUE_APP_PRIMARY_COLOR)
    root.style.setProperty('--primary-fore-color', process.env.VUE_APP_PRIMARY_FORE_COLOR)
    root.style.setProperty('--background-color', process.env.VUE_APP_BACKGROUND_COLOR)
  }
}
</script>

<style lang="scss">
:root {
  --primary-color: #1f4e79;
  --primary-background-color: var(--primary-color);
  --primary-fore-color: white;
  --primary-border-color: var(--primary-color);
  --background-color: white;
}
html {
  height: 100%;
  font-size: 10px;
}
body {
  --header-height: 3.6em;
  --footer-height: 1.2em !important;
  --content-width: 128rem;
  height: 100%;
  font-size: 1.4rem;
  max-width: var(--content-width);
  margin-left: calc((100vw - var(--content-width)) / 2);
  background-color: var(--background-color);
  [class^=el-],
  [class~=el-input] {
    font-size: 1em;
  }
  .el-header,
  .el-menu,
  .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal>.el-submenu
  .el-submenu__title:hover {
    background-color: var(--background-color);
  }
  .el-button {
    &.el-button--primary {
      border-radius: 0.8rem;
      background-color: var(--primary-background-color);
      border-color: var(--primary-border-color);
    }
  }
  .el-input__inner:focus {
    border-color: var(--primary-border-color);
  }
  .el-textarea__inner:focus {
    border-color: var(--primary-border-color);
  }
  .el-select {
    .el-input.is-focus {
      .el-input__inner {
        border-color: var(--primary-border-color);
      }
    }
    .el-input__inner:focus {
      border-color: var(--primary-border-color);
    }
  }
  .el-link {
    &.el-link--primary {
      color: var(--primary-border-color);
    }
  }
  .el-form-item__error {
    position: absolute;
    width: max-content;
    max-width: 10wh;
    font-size: 13px !important;
    font-weight: bold;
  }
  .el-message {
    width: max-content;
    max-width: calc(var(--content-width) * 0.8);
    &.is-closable {
      .el-message__content {
        padding-right: 1em;
      }
    }
  }
  .el-message-box {
    .el-button {
      &.el-button--primary {
        border-radius: 3px;
      }
    }
    .el-message-box__message {
      white-space: pre-line;
    }
  }
  .el-form--inline {
    .el-form-item {
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
  .el-table .sort-caret.ascending.active,
  .el-table .ascending .sort-caret.ascending {
    border-bottom-color: var(--primary-color) !important;
  }
  .el-table .sort-caret.descending.active,
  .el-table .descending .sort-caret.descending {
    border-top-color: var(--primary-color) !important;
  }
  .el-table .caret-wrapper {
      width: 10px !important;
  }
}
</style>
